import { createAsyncThunk,createSlice } from "@reduxjs/toolkit"
import { fetchWrapper } from "../_helpers";

//Create Slice
const name = "term";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({name,initialState,reducers,extraReducers});

//exports
export const termActions = {...slice.actions, ...extraActions}
export const termReducer = slice.reducer;

//implementation
function createInitialState() {
    return {
        term: {},
        termList: [],
        error: null,
         isLoading:false,
        termResponse: [],
        deleteTermResponse: []
    }
}
function createReducers() {
    return {
        clearTermResponse
    };

    function clearTermResponse(state) {
        
        state.termResponse = [];
        state.deleteTermResponse= [];
    }
}


function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/Terms`;
    return {
        getTermAll: getTermAll(),
        getTermById: getTermById(),
        saveTerm: saveTerm(),
        deleteTerm: deleteTerm(),
    }

    function getTermAll() {
        return createAsyncThunk(
            `${name}/getTermAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetTermDetails`)
        );
    }

    function getTermById() {
        return createAsyncThunk(
            `${name}/getTermById`,
             async (detail) => await fetchWrapper.get(`${baseUrl}/GetTermDetails?TermID=`+detail.TermID)
        );
    }

    function saveTerm() {
        return createAsyncThunk(
            `${name}/saveTerm`,
             async (addFormData) => await fetchWrapper.post(`${baseUrl}/InsertUpdateTerms`,addFormData )
        );
    }

    function deleteTerm()
    {
        return createAsyncThunk(
            `${name}/deleteTerm`,
             async (detail) => await fetchWrapper.post(`${baseUrl}/DeleteTerm?TermID=${detail.TermID}&DeletedBy=${detail.DeletedBy}`)
        );
    }
   
}


function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getTermAll.pending, (state) => { //getTermAll
            state.isLoading = false;
            state.error = "";
        })
        .addCase(extraActions.getTermAll.fulfilled, (state, action) => {
            state.isLoading = true;
            state.termList = action.payload || [];
            state.termResponse = [];
            state.deleteTermResponse = [];
        })
        .addCase(extraActions.getTermAll.rejected, (state, action) => {
            state.isLoading = true;
            state.error = { error: action.error };
        })
        .addCase(extraActions.getTermById.pending, (state) => { //getTermById
            state.term = { loading: true };
        })
        .addCase(extraActions.getTermById.fulfilled, (state, action) => {
            state.term = action.payload ? action.payload[0] : null;
            state.termResponse = [];
            state.deleteTermResponse = [];
        })
        .addCase(extraActions.getTermById.rejected, (state, action) => {
            state.term = { error: action.error };
        })
        .addCase(extraActions.saveTerm.pending, (state) => { //saveTerm
            state.termResponse = { loading: true };
        })
        .addCase(extraActions.saveTerm.fulfilled, (state, action) => {
            state.termResponse = action.payload;
            state.deleteTermResponse = [];
        })
        .addCase(extraActions.saveTerm.rejected, (state, action) => {
            state.termResponse = { error: action.error };
        })
        .addCase(extraActions.deleteTerm.pending, (state) => { //deleteTerm
            state.termResponse = { loading: true };
        })
        .addCase(extraActions.deleteTerm.fulfilled, (state, action) => {
            state.deleteTermResponse = action.payload;
            state.termResponse = [];
        })
        .addCase(extraActions.deleteTerm.rejected, (state, action) => {
            state.deleteTermResponse = { error: action.error };
        });
}
